import React from "react";

/**
 * Universal Page Loader Component
 * Matches the design from Task Control Tracker with hourglass icon and emerald theme
 */
const PageLoader = ({
  loadingText = "Loading...",
  description = "",
  size = "default", // "small", "default", "large"
  variant = "default", // "default", "minimal", "fullscreen"
  className = "",
  showSpinner = false, // Optional: show spinning hourglass
  onRetry = null, // Optional: retry button
  error = null // Optional: show error state instead
}) => {
  // Size configurations
  const sizeConfig = {
    small: {
      icon: "text-4xl",
      title: "text-lg",
      description: "text-sm",
      container: "min-h-[300px]"
    },
    default: {
      icon: "text-6xl",
      title: "text-xl",
      description: "text-base",
      container: "min-h-[500px]"
    },
    large: {
      icon: "text-8xl",
      title: "text-2xl",
      description: "text-lg",
      container: "min-h-[600px]"
    }
  };

  // Variant configurations
  const variantConfig = {
    default: "bg-slate-50",
    minimal: "bg-white",
    fullscreen: "min-h-screen bg-slate-50"
  };

  const config = sizeConfig[size];
  const variantClass = variantConfig[variant];

  // Error state
  if (error) {
    return (
      <div className={`${variantClass} flex items-center justify-center ${config.container} ${className}`}>
        <div className="text-center">
          <div className="text-red-600 text-6xl mb-4">❌</div>
          <div className={`font-medium text-slate-900 ${config.title}`}>Error loading data</div>
          <div className={`text-slate-600 mb-4 ${config.description}`}>{error}</div>
          {onRetry && (
            <button
              onClick={onRetry}
              className="px-4 py-2 bg-emerald-600 text-white text-sm rounded-md hover:bg-emerald-700 transition-colors"
            >
              Try Again
            </button>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className={`${variantClass} flex items-center justify-center ${config.container} ${className}`}>
      <div className="text-center">
        <div className={`text-emerald-600 mb-4 ${config.icon} ${showSpinner ? 'animate-spin' : ''}`}>
          ⏳
        </div>
        <div className={`font-medium text-slate-900 ${config.title}`}>
          {loadingText}
        </div>
        {description && (
          <div className={`text-slate-600 ${config.description}`}>
            {description}
          </div>
        )}
      </div>
    </div>
  );
};

export default PageLoader;

